import Route from 'cio/routes/base';

import LoginController from 'cio/pods/login/controller';

export default class LoginPassword extends Route {
  redirect() {
    let { email } = this.controllerFor('login') as LoginController;

    if (!email) {
      return this.router.transitionTo('login');
    }

    return;
  }
}
